<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline row">
                        <div class="col-xs-12 col-xl-10 col-sm-fill hidden-xs">
                            <h3>
                                <i class="las" :class="$router.currentRoute.meta.icon"></i>
                                {{$router.currentRoute.meta.title}}
                            </h3>
                        </div>
                        <div class="col-xs-12 col-sm-fit">
                            <router-link class="button button-lg color-primary margin-top-10" :to="{'name': 'CadastrarPlanejamentos', 'query': {'t': (new Date().getTime())}}" style="width: 100%;">
                                Adicionar <i class="las la-plus-circle"></i>
                            </router-link>
                        </div>
                    </div>

                    <div class="row margin-top-20">
                        <div class="col-xl-12 margin-bottom-20">
                            <p class="help">
                                <i class="las la-question-circle"></i>
                                Adicione planejamentos e agende visitas a clientes para toda sua equipe externa em poucos cliques.
                            </p>
                        </div>
                        <div class="col-xl-12">

                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="form.page = 1;get(true);" novalidate="">
                                <div class="flex-xl-nowrap row">
                                    <div class="col-xs-12 col-md-6 col-lg-4">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Pesquisa:</h5>
                                            <input type="text" placeholder="Pesquise aqui.." required="" class="with-border margin-bottom-0" v-model="form.pesquisa">
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-6 col-lg-3">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Equipe:</h5>
                                            <select class="with-border" v-model="form.equipeCod">
                                                <option value="" disabled selected="">
                                                    Selecione..
                                                </option>
                                                <option v-for="(item, index) in equipes.itens" :key="item.cod" :value="item.cod">{{item.nome}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-md-4 col-lg-2">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>De:</h5>
                                            <input type="date" required="" class="with-border margin-bottom-0" v-model="form.dataInicio">
                                        </div>
                                    </div>        
                                    <div class="col-xs-6 col-md-4 col-lg-2">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Até:</h5>
                                            <input type="date" required="" class="with-border margin-bottom-0" v-model="form.dataFinal">
                                        </div>
                                    </div>         
                                    <div class="col-xs-fit align-self-md-end">
                                        <div class="submit-field margin-bottom-10">
                                            <button class="button color-gray" style="height: 50px; width: 100%;">
                                                <i class="las la-search"></i>
                                            </button>  
                                        </div>
                                    </div>                                    
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form>                         
                        </div>                         
                        
                        <div class="col-xl-12 col-xs-12">
                            <div v-show="data.itens.length == 0 && data.loaded">
                                <center>
                                    <img src="static/images/empty.svg" style="width: 300px;">
                                    <h3 class="center" style="line-height: 120%; font-weight: 200">
                                        Nenhum resultado encontrado.
                                    </h3>
                                </center>     
                            </div>   

                            <div class="parent table-scroll margin-top-30" style="overflow-x: auto !important; border: 1px solid #ddd;" v-if="data.loaded && data.itens.length > 0">
                                <table class="child table table-bordered  table-responsive table-bordered-default">
                                    <thead>
                                        <th style="min-width: 70px; width: 70px;">
                                            ID
                                        </th>
                                        <th style="min-width: 200px;">
                                            Nome do planejamento
                                        </th>
                                        <th style="min-width: 170px;">
                                            Nome da equipe
                                        </th>
                                        <th style="min-width: 80px; width: 80px; text-align: center;">
                                            Clientes
                                        </th>
                                        <th style="min-width: 180px; width: 180px;">
                                            Periodo de visitas
                                        </th> 
                                        <th style="min-width: 130px; width: 130px; text-align: center;">
                                            Status
                                        </th>              
                                        <th style="min-width: 120px; width: 120px; text-align: center;">
                                            Ações
                                        </th>
                                    </thead>
                                    <tbody>   
                                        <tr v-for="(item, index) in data.itens" :key="item.cod" v-bind:class="{'bloqueado': item.ativo == -1}">
                                            <td data-label="ID:">
                                                <b>
                                                    #{{item.id}}
                                                </b>
                                            </td>
                                            <td data-label="Nome da planejamento:" style="">
                                                <a >
                                                    {{item.nome}}
                                                </a>
                                            </td>
                                            <td data-label="Nome da equipe:" style="">
                                                <a v-for="(item2, index2) in item.equipes" v-on:click="$root.go('EditarEquipes', JSON.stringify({'c': item2.cod}))" style="display: block;">
                                                    {{item2.nome}}
                                                </a>
                                            </td>
                                            <td data-label="Clientes:" style="text-align: center;">
                                                <a>
                                                    {{item.clientes.length}}
                                                </a>
                                            </td>
                                            <td data-label="Periodo de visitas:">
                                                <a>
                                                    <span>{{item.dataInicio | formatDate}}</span> <span v-if="item.dataFinal != '0000-00-00'">- {{item.dataFinal | formatDate}}</span>
                                                </a>
                                            </td>
                                            <td data-label="Status:" style="text-align: center;">
                                                <a class="dashboard-status-button color-orange" style="display: inline-block; text-align: center; margin-top: 3px;" v-if="item.status == 0">
                                                    Pendente
                                                </a>
                                                <a class="dashboard-status-button color-blue" style="display: inline-block; text-align: center; margin-top: 3px;" v-if="item.status == 1">
                                                    Em andamento
                                                </a>
                                                <a class="dashboard-status-button color-red" style="display: inline-block; text-align: center; margin-top: 3px;" v-if="item.status == -1">
                                                    Cancelado
                                                </a>
                                                <a class="dashboard-status-button color-green" style="display: inline-block; text-align: center; margin-top: 3px;" v-if="item.status == 2">
                                                    Finalizado
                                                </a>
                                            </td>
                                            <td data-label="Ações:" style="text-align: center;">
                                                <p class="segmented segmented-raised segmented-round">
                                                    <button v-on:click="$root.go('EditarPlanejamentos', JSON.stringify({'c': item.cod}))" class="button button-round color-primary">
                                                        <i class="las la-edit"></i>
                                                    </button>  
                                                    <button v-bind:class="{'disabled': item.status == 0}" v-on:click="$root.go('DetalhesPlanejamentos', JSON.stringify({'c': item.cod}))" class="button button-round  color-green" style="min-width: 120px">
                                                        <i class="las la-eye"></i> Visualizar
                                                    </button>                                                                                                      
                                                    <button v-on:click="del(item.cod)" class="button button-round button-danger color-red">
                                                        <i class="las la-trash"></i>
                                                    </button>
                                                </p>
                                            </td>               
                                        </tr> 
                                    </tbody>
                                </table>
                            </div>

                            <div class="pagination-container margin-top-60 margin-bottom-60">
                                <nav class="pagination">
                                    <ul>
                                        <li class="pagination-arrow" v-show="data.page > 1" v-on:click="form.page = (data.page - 1); get(true);">
                                            <a>
                                                <i class="material-icons">arrow_back</i>
                                                Anterior
                                            </a>
                                        </li>
                                        <li class="pagination-arrow" v-show="data.page >= 1 && data.page < (data.pages.length)" v-on:click="form.page = (data.page + 1); get(true);">
                                            <a>
                                                Próxima
                                                <i class="material-icons">arrow_forward</i>
                                            </a>
                                        </li>    
                                        <br class="hidden-lg hidden-xl hidden-md">                                        
                                        <li v-for="(item, index) in data.pages" v-show="item.show">
                                            <a class="" v-bind:class="{'current-page': item.index == data.page}" v-on:click="form.page = item.index; get(true);">
                                                {{item.index}}
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>

                        </div>
                    </div>            

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Planejamentos',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },     
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toFixed(2).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0.00";
            }
        },        
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            return date + (time ? (" " + time) : "");
        }
    },        
    data () {
        var self                    = this;
        return {
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "equipes": {
                "itens":            []
            },            
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "equipeCod":        "",
                "page":             1
            }              
        }
    },
    methods: {    
        getEquipes: function() {
            var self        = this;
            console.log("getEquipes()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "page":         1
                    }
                };

                axios.get("api/equipes.php", form)
                .then(response => {
                    
                    console.log("getEquipes() response", response);
                    self.equipes       = response.data.result;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getEquipes() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },              
        get: function(e) {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/planejamentos.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    loading.hide();
                    self.$forceUpdate();
                    resolve(response.data.result);
                    self.$root.scrollTop();                    
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    if (e) loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },    
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                loading.show();
                
                axios.delete("api/planejamentos.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }                           
    },
    created: function() {
        var self = this;
    },
    activated: function() {
        var self = this;

        loading.show();
        Promise.resolve()
        .then(self.get)
        .then(self.getEquipes)
        .then(function() {              
            loading.hide();
        }).catch(function(error) {
            console.log("erro ao buscar", error);
            loading.hide();
        });
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bloqueado {
        opacity: 0.5 !important;
    }

    .card .dashboard-status-button {
        margin-top: 8px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Planejamentos.vue